import ElBreadcrumb from './Breadcrumb.vue'

/* istanbul ignore next */
ElBreadcrumb.install = function (app) {
  app.component(ElBreadcrumb.name, ElBreadcrumb)
}

export default ElBreadcrumb
